import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: 'root'
})
export class CandidateProfileService {

  constructor(private readonly httpClient: HttpClient) { }


  //upload candidate profile
  uploadCandidateProfile(id:any  ,payload:any){
    return this.httpClient.patch(`${environment.baseUrl}/candidate/update-candidate-profile/${id}`,payload)
  }
  
  //upload candidate summary
  uploadCandidateSummary(id:any  ,payload:any){
    return this.httpClient.patch(`${environment.baseUrl}/candidate/update-candidate-summary/${id}`,payload)
  }

  //add candidate personal info
  addCandidatePersonalInfo(id:any  ,payload:any){
      return this.httpClient.patch(`${environment.baseUrl}/candidate/update-candidate-personal-info/${id}`,payload)
  }

  //add candidate Identification Documents 
  addCandidateIdentification(id:any  ,payload:any){
      return this.httpClient.patch(`${environment.baseUrl}/candidate/update-candidate-identification-docs/${id}`,payload)
  }

  //add candidate skills 
  addCandidateSkills(id:any  ,payload:any){
      return this.httpClient.patch(`${environment.baseUrl}/candidate/save-candidate-skills/${id}`,payload)
  }

  //delete candidate skills 
  deleteCandidateSkills(candidateId:any , educationId: any){
    return this.httpClient.patch(`${environment.baseUrl}/candidate/remove-candidate-skill/${candidateId}/${educationId}` , {})
  } 

  //add candidate recent experience
  addCandidateRecentExperience(id:any  ,payload:any){
      return this.httpClient.patch(`${environment.baseUrl}/candidate/save-candidate-experience/${id}`,payload)
  }

  //upload candidate experience
  uploadCandidateYearOfExperience(id:any  ,payload:any){
      return this.httpClient.patch(`${environment.baseUrl}/candidate/save-candidate-experience/${id}`,payload)
    }

  //delete candidate experience 
  deleteCandidateYearOfExperience(candidateId:any , educationId: any){
      return this.httpClient.delete(`${environment.baseUrl}/candidate/delete-candidate-experience/${candidateId}/${educationId}` , {})
    }  
    
  //update candidate experience
  updateCandidateExperience(payload:any , id:any , updateSpecificDataId:any){
      return this.httpClient.patch(`${environment.baseUrl}/candidate/update-candidate-experience/${id}/${updateSpecificDataId}`,payload)
    } 
    
  //add candidate timesheet
  addTimeSheet(payload:any){
    return this.httpClient.post(`${environment.baseUrl}/candidate-time-sheet-management/save-timesheet-data`,payload)
  }  


  //update candidate timesheet
  updateTimeSheet(timeSheetId:any , timesheetEntryId:any ,payload:any){
    return this.httpClient.patch(`${environment.baseUrl}/candidate-time-sheet-management/update-timesheet/${timeSheetId}/${timesheetEntryId}`,payload)
  } 

   //get all timesheets
   getAllTimeSheets(currentPage: number,
    totalItemPerPage: number){
    return this.httpClient.get(`${environment.baseUrl}/candidate-time-sheet-management/fetch-all-timesheets/${currentPage}/${totalItemPerPage}`)
  }

  //get all timesheets for specific candidate
  getAllTimeSheetsForSpecificCandidate(employerEmail:any , candidateEmail:any , startDate:any , endDate:any){
    return this.httpClient.get(`${environment.baseUrl}/candidate-time-sheet-management/fetch-timesheet?employerEmail=${employerEmail}&candidateEmail=${candidateEmail}&startDate=${startDate}&endDate=${endDate}`)
  }

  //delete specific timesheet 
  deleteSpecificTimeSheet(timeSheetId:any , timesheetEntryId:any){
    return this.httpClient.delete(`${environment.baseUrl}/candidate-time-sheet-management/delete-timesheet-entry/${timeSheetId}/${timesheetEntryId}`)
  } 

  //save candidate newsletter
  saveNewsLetter(email:any){
    return this.httpClient.post(`${environment.baseUrl}/newsletter-management/create-newsletter/${email}`, {} )
  }  
}

